import { render } from "./PricingList.vue?vue&type=template&id=bd28a660&scoped=true"
import script from "./PricingList.vue?vue&type=script&lang=js"
export * from "./PricingList.vue?vue&type=script&lang=js"

import "./PricingList.vue?vue&type=style&index=0&id=bd28a660&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd28a660"]])

export default __exports__